import React from "react";
import { useNavigate } from "react-router-dom";
import { B2BLayout } from "../../components/b2b/B2BLayout";
import { IMG } from "../../lib/b2b";
import { Building2, CalendarRange, History, UserCog, Wrench, FileText, ArrowRight, ChevronRight } from "lucide-react";

const Row = ({ icon: Icon, title, text }) => (
  <div className="flex gap-4">
    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#0B1F3A] text-[#0E7C7B]"><Icon className="h-5 w-5" /></div>
    <div><h3 className="font-display text-base font-bold text-[#0B1F3A]">{title}</h3><p className="mt-1 text-sm text-[#0B1F3A]/60">{text}</p></div>
  </div>
);

export default function B2BPropertyManagers() {
  const nav = useNavigate();
  return (
    <B2BLayout>
      <section className="mx-auto max-w-6xl px-5 py-12">
        <div className="grid items-center gap-8 lg:grid-cols-2">
          <div>
            <span className="inline-block rounded-full bg-[#0E7C7B]/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-[#0E7C7B]">Per property manager</span>
            <h1 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-[#0B1F3A] sm:text-4xl">Un unico referente per tutto il portafoglio</h1>
            <p className="mt-3 text-base text-[#0B1F3A]/70">Organizza i controlli di decine di immobili con inventari separati, calendari per zona e uno storico sempre consultabile.</p>
          </div>
          <img src={IMG.rome} alt="Immobili a Roma" className="aspect-[4/3] w-full rounded-3xl object-cover shadow-lg" />
        </div>

        <div className="mt-10 grid gap-6 sm:grid-cols-2">
          <Row icon={Building2} title="Gestione di più immobili" text="Inventari separati per ogni unità del portafoglio." />
          <Row icon={CalendarRange} title="Calendario delle visite per zona" text="Visite organizzate per area per ottimizzare i tempi." />
          <Row icon={History} title="Storico degli interventi" text="Cronologia e report consultabili per ciascun immobile." />
          <Row icon={UserCog} title="Un referente dedicato" text="Una commerciale per richieste e preventivi." />
          <Row icon={Wrench} title="Lavori extra dopo approvazione" text="Gli interventi straordinari partono solo con il tuo ok." />
          <Row icon={FileText} title="Proposta personalizzata" text="Una proposta su misura per il tuo portafoglio." />
        </div>

        <div className="mt-10 rounded-3xl bg-[#0E7C7B] p-6 text-white sm:p-8">
          <p className="text-xs font-bold uppercase tracking-wide text-white/70">Esempio operativo</p>
          <p className="mt-2 font-display text-lg font-bold sm:text-xl">Con il piano Pro su 5 appartamenti hai 10 visite programmate complessive all'anno, fino a 2 split inclusi per unità e uno storico separato per ogni immobile.</p>
        </div>

        <div className="mt-8 text-center">
          <button data-testid="pm-cta" onClick={() => nav("/contatti", { state: { portfolio: true } })} className="inline-flex items-center gap-2 rounded-full bg-[#F97316] px-6 py-3.5 font-bold text-white shadow-lg transition hover:brightness-110">Richiedi una proposta per il tuo portafoglio <ArrowRight className="h-5 w-5" /></button>
        </div>
      </section>
    </B2BLayout>
  );
}
